module.exports = __webpack_public_path__ + "static/media/shine.3fb570b7.png";